import CarEntity from "../../domain/entities/CarEntity";

export type WarrantyVariant = "sixMonths" | "factory" | "oneYear";

export interface WarrantyBadge {
    label: string;
    variant: WarrantyVariant;
    className: string;
    cardClassName: string;
    iconFill: string;
}

const BADGE_BY_VARIANT: Record<WarrantyVariant, Pick<WarrantyBadge, "className" | "cardClassName" | "iconFill">> = {
    sixMonths: { className: "warranty", cardClassName: "warranty", iconFill: "#000" },
    factory: { className: "warranty2", cardClassName: "warranty2", iconFill: "#fff" },
    oneYear: { className: "warranty3-detail", cardClassName: "warranty3", iconFill: "#000" },
};

/** Variante visual por `warranty_plan_car.id`.  */
const VARIANT_BY_PLAN_ID: Record<number, WarrantyVariant> = {
    1: "factory",
    2: "sixMonths",
    3: "oneYear",
};

/** `warranty_plan_car` es la única fuente de verdad: sin plan no hay garantía. */
export const hasWarrantyPlan = (car: CarEntity): boolean => !!car.warranty_plan_car;

/** Etiqueta de garantía del vehículo: texto desde `warranty_plan_car.name`, estilo desde su `id`. */
export const getWarrantyBadge = (car: CarEntity): WarrantyBadge => {
    const plan = car.warranty_plan_car;
    const variant = (plan && VARIANT_BY_PLAN_ID[plan.id]) ?? "sixMonths";
    return { label: plan?.name ?? "", variant, ...BADGE_BY_VARIANT[variant] };
};
